import { render, staticRenderFns } from "./detail-kiosk-purchase.vue?vue&type=template&id=527a0b50&"
import script from "./detail-kiosk-purchase.vue?vue&type=script&lang=js&"
export * from "./detail-kiosk-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports